import DOM from "./util/dom"
import misc from "./util/misc"
import validations from "./util/validations"
import windowOpen from "./util/window"
export * from "./util/misc"

const Util = {
  ...misc,
  validations,
  windowOpen,
  misc,
  DOM,
}

export default Util
